import React, { useEffect, useState } from "react";
import { Drawer, Select, DatePicker, Spin } from "antd";
import axios from "axios";
import PropTypes from "prop-types";
// import { CloseOutlined } from "@ant-design/icons";
import { BASE_CRM_URL } from "../../../components/config/config";
import Swal from "sweetalert2";
import dayjs from "dayjs";
// import Swal from "sweetalert2";
// import dayjs from "dayjs";

const NewProject = ({
  open,
  onClose,
  onSuccess,
  getProjects,
  customerId,
  type,
  onProjectAdded,
}) => {
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;

  const [formData, setFormData] = useState({});

  const [loading, setLoading] = useState(false);

  const isRelatedLocked = Boolean(type);
  const [errors, setErrors] = useState({});

  const [customerOptions, setCustomerOptions] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  console.log(selectedCustomer, "cccccccccccccccccccccc");

  const getCustomers = async () => {
    try {
      const response = await fetch(`${BASE_CRM_URL}customers/GetCustomers`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.customerId,
          label: item.company,
        }));

        setCustomerOptions(options);
      }
    } catch (error) {
      console.error("Error fetching related types:", error);
    }
  };

  const [staffData, setStaffData] = useState([]);
  const [staffLoading, setStaffLoading] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(null);

  const getStaffDropDown = async () => {
    setStaffLoading(true);

    try {
      const response = await axios.get(`${BASE_CRM_URL}staff/GetStaffDropdown`);

      if (response.data?.Status) {
        const data = response.data.ResultData || [];

        const options = data.map((staff) => ({
          value: staff.staffid,
          label: `${staff.firstname} ${staff.lastname}`,
        }));

        setStaffData(options);
      }
    } catch (error) {
      console.error("Leads API Error:", error);
    } finally {
      setStaffLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      getCustomers();
      getStaffDropDown();
    }
  }, [open]);

  useEffect(() => {
    if (customerId && customerOptions.length > 0) {
      const customer = customerOptions.find(
        (item) => Number(item.value) === Number(customerId),
      );

      if (customer) {
        setSelectedCustomer(customer?.value);
      }
    }
  }, [customerId, customerOptions]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!formData.name?.trim()) {
      newErrors.name = "Project name is required";
    }

    if (!selectedCustomer) {
      newErrors.customer = "Customer is required";
    }

    if (!formData.start_date) {
      newErrors.start_date = "Start date is required";
    }

    if (!formData.deadline) {
      newErrors.deadline = "End date is required";
    }

    if (
      formData.start_date &&
      formData.deadline &&
      formData.deadline.isBefore(formData.start_date, "day")
    ) {
      newErrors.deadline = "End date cannot be before start date";
    }

    setErrors(newErrors);

    // Stop submit if validation errors exist
    if (Object.keys(newErrors).length > 0) {
      return;
    }

    try {
      setLoading(true);

      const payload = {
        name: formData.name.trim(),
        description: formData.description || "",

        clientid: selectedCustomer,

        status: 1,
        billing_type: 1,

        project_created: dayjs().format("YYYY-MM-DD"),

        start_date: formData.start_date.format("YYYY-MM-DD"),
        deadline: formData.deadline.format("YYYY-MM-DD"),

        progress: 0,
        progress_from_tasks: 0,
        project_cost: 0,
        project_rate_per_hour: 0,
        estimated_hours: 0,

        addedfrom: userId,

        staff_id: selectedStaff || [],
      };

      console.log("Add Project Payload:", payload);

      const response = await axios.post(
        `${BASE_CRM_URL}project/AddProject`,
        payload,
      );

      console.log("Add Project Response:", response.data);

      if (response.data?.Status === true) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data?.Message || "Project created successfully",
          confirmButtonText: "OK",
        });

        setFormData({});
        setErrors({});
        setSelectedCustomer(null);
        setSelectedStaff([]);

        if (onProjectAdded) {
          await onProjectAdded();
        } else if (getProjects) {
          await getProjects();
        }

        onSuccess?.();
        setLoading(false);
        onClose?.();
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: response.data?.Message || "Failed to create project",
        });
      }
    } catch (error) {
      console.error("Add Project Error:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.Message ||
          "Something went wrong while creating project",
      });
    } finally {
      setLoading(false);
    }
  };

  const handelresret = () => {
    setFormData({});
    setErrors({});
    setSelectedStaff([]);
    setSelectedCustomer(null);
    onClose();
  };

  return (
    <div>
      {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}

      <Drawer
        title="Add New Project"
        placement="right"
        width={600}
        open={open}
        onClose={handelresret}
        destroyOnClose
        maskClosable={!loading}
        closable={false}
        extra={
          <div className="d-flex align-items-center gap-2">
            {/* Close */}
            <button
              type="button"
              onClick={handelresret}
              disabled={loading}
              className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
              style={{
                width: "35px",
                height: "35px",
                backgroundColor: "#e40d22",
                color: "#fff",
                border: "none",
              }}
              title="Close"
            >
              <i className="fa fa-times" />
            </button>

            {/* Save */}
            <button
              type="button"
              onClick={handleSubmit}
              disabled={loading}
              className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
              style={{
                width: "35px",
                height: "35px",
                backgroundColor: "#07f083",
                color: "#fff",
                border: "none",
              }}
              title="Save"
            >
              {loading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <i className="fa fa-check" />
              )}
            </button>
          </div>
        }
      >
        <form id="projectForm" onSubmit={handleSubmit}>
          <div className="row">
            {/* Project Name */}
            <div className="col-12 mb-3">
              <label className="form-label">
                Project Name <span className="text-danger">*</span>
              </label>

              <input
                type="text"
                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                placeholder="Enter project name"
                value={formData.name || ""}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    name: e.target.value,
                  });

                  if (errors.name) {
                    setErrors({
                      ...errors,
                      name: "",
                    });
                  }
                }}
              />

              {errors.name && (
                <div className="text-danger small mt-1">{errors.name}</div>
              )}
            </div>

            {/* Start Date */}
            <div className="col-md-6 mb-3">
              <label className="form-label">
                Start Date <span className="text-danger">*</span>
              </label>

              <DatePicker
                className={`w-100 ${errors.start_date ? "border-danger" : ""}`}
                format="DD-MM-YYYY"
                placeholder="Select start date"
                value={formData.start_date}
                onChange={(date) => {
                  setFormData({
                    ...formData,
                    start_date: date,
                  });

                  if (errors.start_date) {
                    setErrors({
                      ...errors,
                      start_date: "",
                    });
                  }
                }}
              />

              {errors.start_date && (
                <div className="text-danger small mt-1">
                  {errors.start_date}
                </div>
              )}
            </div>
            {/* Deadline */}
            <div className="col-md-6 mb-3">
              <label className="form-label">
                End Date <span className="text-danger">*</span>
              </label>

              <DatePicker
                className={`w-100 ${errors.deadline ? "border-danger" : ""}`}
                format="DD-MM-YYYY"
                placeholder="Select deadline"
                value={formData.deadline}
                disabledDate={(current) => {
                  const startDate = formData.start_date;

                  return (
                    startDate && current && current.isBefore(startDate, "day")
                  );
                }}
                onChange={(date) => {
                  setFormData({
                    ...formData,
                    deadline: date,
                  });

                  if (errors.deadline) {
                    setErrors({
                      ...errors,
                      deadline: "",
                    });
                  }
                }}
              />

              {errors.deadline && (
                <div className="text-danger small mt-1">{errors.deadline}</div>
              )}
            </div>
            {/* Customer */}
            <div className="col-6 mb-3">
              <label className="form-label">
                Customer <span className="text-danger">*</span>
              </label>

              <Select
                showSearch
                placeholder="Select Customer"
                optionFilterProp="label"
                className={`w-100 ${errors.customer ? "border border-danger rounded" : ""}`}
                style={{ height: 38 }}
                options={customerOptions}
                value={selectedCustomer}
                disabled={isRelatedLocked}
                onChange={(value) => {
                  setSelectedCustomer(value);

                  if (errors.customer) {
                    setErrors({
                      ...errors,
                      customer: "",
                    });
                  }
                }}
              />

              {errors.customer && (
                <div className="text-danger small mt-1">{errors.customer}</div>
              )}
            </div>

            {/* Status */}
            {/* <div className="col-md-6 mb-3">
            <label className="form-label">Status</label>

            <Select
              className="w-100"
              placeholder="Select status"
              value={formData.status}
              style={{height:38}}
              onChange={(value) =>
                setFormData({
                  ...formData,
                  status: value,
                })
              }
              options={[
                {
                  value: 1,
                  label: "Not Started",
                },
                {
                  value: 2,
                  label: "In Progress",
                },
                {
                  value: 3,
                  label: "Finished",
                },
                {
                  value: 4,
                  label: "Cancelled",
                },
              ]}
            />
          </div> */}

            {/* Members */}
            <div className="col-6 mb-3">
              <label className="form-label">Project Members</label>

              <Select
                mode="multiple"
                className="w-100"
                placeholder="Select project members"
                style={{ height: 38 }}
                showSearch
                allowClear
                loading={staffLoading}
                optionFilterProp="label"
                options={staffData}
                value={selectedStaff}
                onChange={(value) => {
                  setSelectedStaff(value);
                }}
              />
            </div>
            <div className="col-12 mb-3">
              <label className="form-label">Description</label>

              <textarea
                className="form-control"
                rows={3}
                placeholder="Enter project description"
                value={formData.description}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    description: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </form>
      </Drawer>
    </div>
  );
};
NewProject.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  getProjects: PropTypes.func.isRequired,
  customerId: PropTypes.number.isRequired,
  type: PropTypes.string,
  onProjectAdded: PropTypes.func.isRequired,
};
export default NewProject;
